import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { applicationStore } from 'src/store/ApplicationStore';
import { pageComponents } from 'src/helpers/uiSortHelper';
import { useNavigate } from 'react-router-dom';
import { workflowStepIterator } from 'src/services/workflowStepIterator';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

const StepIterator = observer(() => {
    const [PageComponent, setPageComponent] = useState(null);
    const { t } = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {
        if (applicationStore.isEddForm === true || applicationStore.isPeriodicForm === true) {
            setPageComponent(pageComponents["form"]);
        } else if (applicationStore.workflowNextServiceResponse?.service_results.length >= 0) {
            setPageComponent(pageComponents[applicationStore.workflowNextServiceResponse?.step]);
        } else {
            applicationStore.setApplicationErrorObj({
                header: t('errors.loadingFlowHeader'),
                description: t('errors.loadingFlowDescription'),
                buttonList: [
                    {
                        label: t('actions.retry'),
                        variant: "primaryWithoutIcon",
                        onClick: async () => {
                            try {
                                const response = await workflowStepIterator({
                                    access_token: applicationStore.access_token,
                                });
                                applicationStore.setWorkflowNextServiceResponse(response.data);
                                navigate("/next", { replace: true });
                            } catch (error) {
                                toast.error(t('errors.generic'));
                            }
                        }
                    }
                ]
            });
            navigate("/error-page", { replace: true });
            return
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [applicationStore.workflowNextServiceResponse, t]);

    return (
        <>
            {PageComponent ? (
                <PageComponent key={applicationStore.workflowNextServiceResponse.node_id} />
            ) : (
                <div></div>
            )}
        </>
    );
});

export default StepIterator;
